import { exportTabReducerKey, chemQuoteExportTabReducerKey } from './ExportTabConstants';

const createSelectors = (reducerKey) => {
  const exportTab = (state) => {
    return state.get(reducerKey);
  };

  const exportType = (state) => {
    return exportTab(state).get('exportType');
  };

  const exportResult = (state) => {
    return exportTab(state).get('exportResult');
  };

  const retryDisabled = (state) => {
    return exportTab(state).get('retryDisabled');
  };

  const downloadUrl = (state) => {
    return exportTab(state).get('downloadUrl');
  };

  const tooltipModalOpened = (state) => {
    return exportTab(state).get('tooltipModalOpened');
  };

  const cancelledJobIds = (state) => {
    return exportTab(state).get('cancelledJobIds');
  };

  return {
    exportTab,
    exportResult,
    exportType,
    retryDisabled,
    downloadUrl,
    tooltipModalOpened,
    cancelledJobIds,
  };
};

export const exportTabSelectors = createSelectors(exportTabReducerKey);
export const chemquoteExportTabSelectors = createSelectors(chemQuoteExportTabReducerKey);
